import { cva } from 'class-variance-authority'

export const tooltipVariants = {
  collapse: cva([
    'flex',
    'items-center',
    'bg-white',
    'dark:bg-surface-primary',
    'cursor-pointer',
    'transition-[shadow,padding,translate]',
    'duration-300',
    'ease-in-out',
  ], {
    variants: {
      direction: {
        up: [],
        down: [],
        left: [],
        right: [],
      },
    },
    compoundVariants: [
      {
        direction: ['up', 'down'],
        class: ['px-xs', 'py-4xs'],
      },
      {
        direction: ['left', 'right'],
        class: ['px-4xs', 'py-xs'],
      },
      {
        direction: 'up',
        class: ['rounded-t-lg', 'hover:pb-xs', 'hover:-translate-y-1', 'shadow-[0_-2px_4px_-1px_rgba(0,0,0,0.1)]'],
      },
      {
        direction: 'down',
        class: ['rounded-b-lg', 'hover:pt-xs', 'hover:translate-y-1', 'shadow-[0_2px_4px_-1px_rgba(0,0,0,0.1)]'],
      },
      {
        direction: 'left',
        class: ['rounded-l-lg', 'hover:pr-xs', 'shadow-[-2px_0_4px_1px_rgba(0,0,0,0.1)]'],
      },
      {
        direction: 'right',
        class: ['rounded-r-lg', 'hover:pl-xs', 'shadow-[2px_0_4px_1px_rgba(0,0,0,0.1)]'],
      },
    ],
  }),
}
